import React, { useState } from 'react';
import { Button, TextField, Container, Typography, Box, Alert, Paper, CircularProgress } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { authApi } from '../api';

function Auth({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Please enter username and password'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await authApi.login(username, password);
      localStorage.setItem('token', res.data.token);
      const meRes = await authApi.me();
      localStorage.setItem('user', JSON.stringify(meRes.data));
      onLogin(meRes.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper sx={{ p: 4, width: '100%' }} elevation={3}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
            <LockOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
            <Typography variant="h5" fontWeight="bold">{process.env.REACT_APP_APP_NAME || 'Measey Swarm'}</Typography>
            <Typography variant="body2" color="text.secondary">Sign in to manage your swarm</Typography>
          </Box>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleLogin}>
            <TextField
              label="Username" fullWidth margin="normal" value={username}
              onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username"
            />
            <TextField
              label="Password" type="password" fullWidth margin="normal" value={password}
              onChange={e => setPassword(e.target.value)} autoComplete="current-password"
            />
            <Button
              type="submit" variant="contained" color="primary" fullWidth
              sx={{ mt: 2, py: 1.2 }} disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
}

export default Auth;
